// Generated by scripts/content_codemod.py (+ manual entries): key -> default text and editing rules. Defaults equal the original copy.
export const REGISTRY = {
 "landing.start_15_day_free_demo": {
  "default": "Start 15-day free demo",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Start 15-day free demo",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.no_credit_card_required": {
  "default": "No credit card required",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "No credit card required",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.how_it_works": {
  "default": "How it works",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "How it works",
  "section": "Header",
  "multiline": false
 },
 "landing.become_a_reseller": {
  "default": "Become a Reseller",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Become a Reseller",
  "section": "ResellerSection",
  "multiline": false
 },
 "landing.open_pos": {
  "default": "Open POS",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Open POS",
  "section": "Header",
  "multiline": false
 },
 "landing.log_in": {
  "default": "Log in",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Log in",
  "section": "Header",
  "multiline": false
 },
 "landing.cloud_pos_retail_pharmacy_restaurant": {
  "default": "Cloud POS · Retail, Pharmacy & Restaurant",
  "required": true,
  "placeholders": [],
  "max_length": 123,
  "kind": "text",
  "page": "Landing",
  "label": "Cloud POS · Retail, Pharmacy & Restaurant",
  "section": "Hero",
  "multiline": false
 },
 "landing.the_counter_that_keeps_up": {
  "default": "The counter that keeps up with the",
  "required": true,
  "placeholders": [],
  "max_length": 102,
  "kind": "text",
  "page": "Landing",
  "label": "The counter that keeps up with the",
  "section": "Hero",
  "multiline": false
 },
 "landing.queue": {
  "default": "queue.",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "queue.",
  "section": "Hero",
  "multiline": false
 },
 "landing.smart_in_retail_is_a": {
  "default": "Smart-in Retail is a fast point of sale for shops and pharmacies. Scan, tap, take cash or card, and print a thermal receipt on the phone, tablet or PC you already own. VAT and GST are worked out for you.",
  "required": false,
  "placeholders": [],
  "max_length": 609,
  "kind": "text",
  "page": "Landing",
  "label": "Smart-in Retail is a fast point of sale for shops and pharma…",
  "section": "Hero",
  "multiline": true
 },
 "landing.premium": {
  "default": "Premium",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Premium",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.new_your_own_online_store": {
  "default": "New: your own Online Store with cash on delivery",
  "required": true,
  "placeholders": [],
  "max_length": 144,
  "kind": "text",
  "page": "Landing",
  "label": "New: your own Online Store with cash on delivery",
  "section": "Hero",
  "multiline": false
 },
 "landing.features": {
  "default": "Features",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Features",
  "section": "Header",
  "multiline": false
 },
 "landing.everything_a_busy_counter_needs": {
  "default": "Everything a busy counter needs. Nothing it doesn't.",
  "required": true,
  "placeholders": [],
  "max_length": 156,
  "kind": "text",
  "page": "Landing",
  "label": "Everything a busy counter needs. Nothing it doesn't.",
  "section": "Features",
  "multiline": false
 },
 "landing.pharmacy": {
  "default": "Pharmacy",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Pharmacy",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.automatic_fefo_for_pharmacies": {
  "default": "Automatic FEFO for pharmacies",
  "required": true,
  "placeholders": [],
  "max_length": 87,
  "kind": "text",
  "page": "Landing",
  "label": "Automatic FEFO for pharmacies",
  "section": "Features",
  "multiline": false
 },
 "landing.every_add_picks_the_batch": {
  "default": "Every add picks the batch that expires first and is still in date. Extra quantity rolls over to the next batch. Expired stock can never be sold. There's no setting to switch on and nothing for staff to choose.",
  "required": false,
  "placeholders": [],
  "max_length": 627,
  "kind": "text",
  "page": "Landing",
  "label": "Every add picks the batch that expires first and is still in…",
  "section": "Features",
  "multiline": true
 },
 "landing.barcode_scanning": {
  "default": "Barcode scanning",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Barcode scanning",
  "section": "Features",
  "multiline": false
 },
 "landing.plug_in_any_usb_or": {
  "default": "Plug in any USB or Bluetooth scanner and scan, no need to click a box first. If a code isn't found, you can add the product right there.",
  "required": false,
  "placeholders": [],
  "max_length": 408,
  "kind": "text",
  "page": "Landing",
  "label": "Plug in any USB or Bluetooth scanner and scan, no need to cl…",
  "section": "Features",
  "multiline": true
 },
 "landing.from_sign_up_to_first": {
  "default": "From sign-up to first receipt before the next customer.",
  "required": true,
  "placeholders": [],
  "max_length": 165,
  "kind": "text",
  "page": "Landing",
  "label": "From sign-up to first receipt before the next customer.",
  "section": "How",
  "multiline": false
 },
 "landing.see_the_full_walkthrough_with": {
  "default": "See the full walkthrough with real screenshots",
  "required": true,
  "placeholders": [],
  "max_length": 138,
  "kind": "text",
  "page": "Landing",
  "label": "See the full walkthrough with real screenshots",
  "section": "How",
  "multiline": false
 },
 "landing.pricing": {
  "default": "Pricing",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Pricing",
  "section": "Header",
  "multiline": false
 },
 "landing.simple_monthly_plans_start_with": {
  "default": "Simple monthly plans. Start with 15 days free.",
  "required": true,
  "placeholders": [],
  "max_length": 138,
  "kind": "text",
  "page": "Landing",
  "label": "Simple monthly plans. Start with 15 days free.",
  "section": "Pricing",
  "multiline": false
 },
 "landing.restaurants": {
  "default": "Restaurants:",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Restaurants:",
  "section": "Pricing",
  "multiline": false
 },
 "landing.every_plan_includes_tables_kots": {
  "default": "every plan includes tables, KOTs, the kitchen view, reservations and Waiter / Kitchen roles. The",
  "required": false,
  "placeholders": [],
  "max_length": 288,
  "kind": "text",
  "page": "Landing",
  "label": "every plan includes tables, KOTs, the kitchen view, reservat…",
  "section": "Pricing",
  "multiline": false
 },
 "landing.online_ordering_add_on": {
  "default": "Online Ordering add-on",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Online Ordering add-on",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.menu_online_delivery_or_pickup": {
  "default": "(menu online, delivery or pickup, kitchen queue) is enabled per restaurant:",
  "required": false,
  "placeholders": [],
  "max_length": 225,
  "kind": "text",
  "page": "Landing",
  "label": "(menu online, delivery or pickup, kitchen queue) is enabled …",
  "section": "Pricing",
  "multiline": false
 },
 "landing.ask_us": {
  "default": "ask us",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "ask us",
  "section": "Pricing",
  "multiline": false
 },
 "landing.to_switch_it_on": {
  "default": "to switch it on.",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "to switch it on.",
  "section": "Pricing",
  "multiline": false
 },
 "landing.faq": {
  "default": "[[\"Does it work for restaurants?\", \"Yes. Choose Restaurant when you sign up and you get a sample menu, sections and tables. Waiters open tables and send KOTs from a phone, the kitchen works from a tablet with New, In progress and Ready, and billing uses the same receipts, tax and reports as the shop POS.\"], [\"What is the Online Ordering add-on for restaurants?\", \"Your menu online by category, with delivery areas, pickup, opening hours and order tracking. Orders arrive as Received; Preparing sends them to the kitchen tagged Online, and Delivered or Collected records the sale. It's enabled per restaurant by our team.\"], [\"Does it work without internet?\", \"Yes. Once you have logged in on a device, the register keeps selling offline with cash or card, using receipt numbers reserved for that device. Sales sync automatically when the connection returns. Returns, credit notes, settings and imports need internet.\"], [\"How do returns and credit notes work?\", \"Scan the barcode on the receipt, pick the items and mark each one Resellable (back to stock) or Damaged. Refund in cash or issue a credit note. The customer uses the credit note in full on their next purchase at the same branch.\"], [\"What is the Inventory add-on?\", \"An optional add-on for Goods Receiving (GRN), put-away to shelf locations and location-aware picking: expiry first for pharmacies, oldest stock first for retail. Each cart line shows where to pick from.\"], [\"Can I sell online?\", \"Yes. The Online Store is a Premium feature included in Growth, Business and Enterprise, and in every free demo. Starter doesn't include it; upgrade any time and your store goes live.\"], [\"Do I get sales reports?\", \"Yes. Reports is a Premium feature included in Growth, Business and Enterprise and in every demo, or you can add the Reports add-on to any plan. See daily, weekly or monthly gross sales, discounts, returns, net revenue, tax and the cash/card/credit note split for all branches or one, plus Profit & Loss: revenue excluding tax, cost of goods sold, gross profit, margin and your top 10 products by profit. Export everything to CSV.\"], [\"How do customers find my store?\", \"Your store gets its own link, like retail.smrtin.net/your-shop. Share it on WhatsApp or social media, or print the QR code for your counter. Customers don't need an account.\"], [\"How do customers pay for online orders?\", \"Cash on delivery, or pay at pickup. There's nothing to set up. When you complete an order you choose Cash or Card and it becomes a normal sale with a printed receipt.\"], [\"Can I set delivery areas and fees?\", \"Yes. Add each area with its own delivery fee, set a minimum order for delivery, and turn delivery or pickup on and off. Weekly opening hours close the store automatically outside your hours.\"], [\"Can I print price tags and import products from Excel?\", \"Yes. Print shelf tags with barcodes in several layouts, and import or update hundreds of products from an Excel or CSV file, with a preview and row-by-row errors before anything is saved.\"], [\"Can I run several branches and staff?\", \"Yes. Each branch has its own receipt numbers and stock. Add managers and cashiers with their own logins, and choose what each role may do: discounts, reprints, products, returns and more.\"], [\"Which countries and taxes are supported?\", \"Every country. We preselect your country, currency, decimals and standard tax (VAT, GST, Sales Tax or Consumption Tax) from your location. In the USA and Canada you also pick your state or province. You can edit the rate and label in Settings at any time.\"], [\"How does the reseller program work?\", \"Apply with the Become a Reseller form. Once approved you get a referral link and code. Shops that sign up with it are linked to you, and you earn 20% of every subscription payment they make. Your portal shows performance, businesses and a downloadable statement.\"], [\"Do I need a credit card for the demo, and what happens after it?\", \"No card is needed. The 15-day demo is fully featured. When it ends the register locks but every product and sale is kept. Request a plan and our team reactivates you, usually the same day.\"]]",
  "required": true,
  "placeholders": [],
  "max_length": 20000,
  "kind": "list",
  "page": "Landing",
  "label": "FAQ questions and answers",
  "section": "Faq",
  "multiline": false
 },
 "landing.questions_shop_owners_ask_us": {
  "default": "Questions shop owners ask us",
  "required": true,
  "placeholders": [],
  "max_length": 84,
  "kind": "text",
  "page": "Landing",
  "label": "Questions shop owners ask us",
  "section": "Faq",
  "multiline": false
 },
 "landing.open_your_register_today_the": {
  "default": "Open your register today. The first 15 days are on us.",
  "required": true,
  "placeholders": [],
  "max_length": 162,
  "kind": "text",
  "page": "Landing",
  "label": "Open your register today. The first 15 days are on us.",
  "section": "FinalCTA",
  "multiline": false
 },
 "landing.cloud_point_of_sale_for": {
  "default": "Cloud point of sale for retail shops and pharmacies, with tax for every country.",
  "required": false,
  "placeholders": [],
  "max_length": 240,
  "kind": "text",
  "page": "Landing",
  "label": "Cloud point of sale for retail shops and pharmacies, with ta…",
  "section": "Footer",
  "multiline": false
 },
 "landing.product": {
  "default": "Product",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Product",
  "section": "Footer",
  "multiline": false
 },
 "landing.reseller_login": {
  "default": "Reseller login",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Reseller login",
  "section": "ResellerSection",
  "multiline": false
 },
 "landing.contact": {
  "default": "Contact",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Contact",
  "section": "Footer",
  "multiline": false
 },
 "landing.contact_us": {
  "default": "Contact us",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Contact us",
  "section": "Footer",
  "multiline": false
 },
 "landing.your_data_stays_yours": {
  "default": "Your data stays yours",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Your data stays yours",
  "section": "Footer",
  "multiline": false
 },
 "landing.inventory_add_on_available": {
  "default": "Inventory add-on available",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Inventory add-on available",
  "section": "Footer",
  "multiline": false
 },
 "landing.pharmacy_counter_with_tablet_pos": {
  "default": "Pharmacy counter with tablet POS and thermal printer",
  "required": true,
  "placeholders": [],
  "max_length": 156,
  "kind": "attr",
  "page": "Landing",
  "label": "Pharmacy counter with tablet POS and thermal printer",
  "section": "Features",
  "multiline": false
 },
 "landing.scanning_a_barcode_at_a": {
  "default": "Scanning a barcode at a grocery counter",
  "required": true,
  "placeholders": [],
  "max_length": 117,
  "kind": "attr",
  "page": "Landing",
  "label": "Scanning a barcode at a grocery counter",
  "section": "Features",
  "multiline": false
 },
 "landing.products": {
  "default": "Products",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Products",
  "section": "Header",
  "multiline": false
 },
 "landing.restaurant": {
  "default": "Restaurant",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Restaurant",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.online_store": {
  "default": "Online Store",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Online Store",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.reports": {
  "default": "Reports",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Reports",
  "section": "Header",
  "multiline": false
 },
 "landing.58_80mm": {
  "default": "58 / 80mm",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "58 / 80mm",
  "section": "Hero",
  "multiline": false
 },
 "landing.pakistan": {
  "default": "Pakistan",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Pakistan",
  "section": "TAX",
  "multiline": false
 },
 "landing.sales_tax_18": {
  "default": "Sales Tax 18%",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Sales Tax 18%",
  "section": "TAX",
  "multiline": false
 },
 "landing.oman": {
  "default": "Oman",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Oman",
  "section": "TAX",
  "multiline": false
 },
 "landing.india": {
  "default": "India",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "India",
  "section": "TAX",
  "multiline": false
 },
 "landing.fast_pos": {
  "default": "Fast POS",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Fast POS",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.big_tap_targets_instant_totals": {
  "default": "Big tap targets, instant totals and the F2 / F9 keys. A three-item cash sale takes six taps.",
  "required": false,
  "placeholders": [],
  "max_length": 276,
  "kind": "string",
  "page": "Landing",
  "label": "Big tap targets, instant totals and the F2 / F9 keys. A thre…",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.thermal_receipt_printing": {
  "default": "Thermal receipt printing",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Thermal receipt printing",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.receipts_sized_for_58mm_or": {
  "default": "Receipts sized for 58mm or 80mm paper, with your header, tax number and footer. Reprint any sale.",
  "required": false,
  "placeholders": [],
  "max_length": 291,
  "kind": "string",
  "page": "Landing",
  "label": "Receipts sized for 58mm or 80mm paper, with your header, tax…",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.vat_gst_by_country": {
  "default": "VAT / GST by country",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "VAT / GST by country",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.sales_tax_vat_or_gst": {
  "default": "Sales Tax, VAT or GST is set from your country. Prices can include or exclude tax, and the maths is exact to the last fils.",
  "required": false,
  "placeholders": [],
  "max_length": 369,
  "kind": "string",
  "page": "Landing",
  "label": "Sales Tax, VAT or GST is set from your country. Prices can i…",
  "section": "FEATURES",
  "multiline": true
 },
 "landing.multi_branch": {
  "default": "Multi-branch",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Multi-branch",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.each_branch_has_its_own": {
  "default": "Each branch has its own stock, sales and receipt numbering, all under one owner account.",
  "required": false,
  "placeholders": [],
  "max_length": 264,
  "kind": "string",
  "page": "Landing",
  "label": "Each branch has its own stock, sales and receipt numbering, …",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.growth": {
  "default": "Growth+",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Growth+",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.staff_roles": {
  "default": "Staff roles",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Staff roles",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.owner_branch_manager_and_cashier": {
  "default": "Owner, Branch Manager and Cashier roles. You decide who can discount, reprint or manage products.",
  "required": false,
  "placeholders": [],
  "max_length": 291,
  "kind": "string",
  "page": "Landing",
  "label": "Owner, Branch Manager and Cashier roles. You decide who can …",
  "section": "FEATURES",
  "multiline": false
 },
 "landing.sign_up_in_a_minute": {
  "default": "Sign up in a minute",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Sign up in a minute",
  "section": "STEPS",
  "multiline": false
 },
 "landing.enter_your_business_name_and": {
  "default": "Enter your business name and type, an email and a password. We pick up your country, currency and tax automatically.",
  "required": false,
  "placeholders": [],
  "max_length": 348,
  "kind": "string",
  "page": "Landing",
  "label": "Enter your business name and type, an email and a password. …",
  "section": "STEPS",
  "multiline": false
 },
 "landing.sell_straight_away": {
  "default": "Sell straight away",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Sell straight away",
  "section": "STEPS",
  "multiline": false
 },
 "landing.about_20_sample_products_are": {
  "default": "About 20 sample products are ready to use. Scan them, tap them, or quick-add your own with a barcode, price and batches.",
  "required": false,
  "placeholders": [],
  "max_length": 360,
  "kind": "string",
  "page": "Landing",
  "label": "About 20 sample products are ready to use. Scan them, tap th…",
  "section": "STEPS",
  "multiline": false
 },
 "landing.print_then_grow": {
  "default": "Print, then grow",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Print, then grow",
  "section": "STEPS",
  "multiline": false
 },
 "landing.print_thermal_receipts_from_the": {
  "default": "Print thermal receipts from the browser. Choose a plan when you're ready; your data stays exactly as you left it.",
  "required": false,
  "placeholders": [],
  "max_length": 339,
  "kind": "string",
  "page": "Landing",
  "label": "Print thermal receipts from the browser. Choose a plan when …",
  "section": "STEPS",
  "multiline": false
 },
 "landing.detecting_your_currency": {
  "default": "Detecting your currency…",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Detecting your currency…",
  "section": "Pricing",
  "multiline": false
 },
 "landing.monthly": {
  "default": "Monthly",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Monthly",
  "section": "Pricing",
  "multiline": false
 },
 "landing.yearly": {
  "default": "Yearly",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Yearly",
  "section": "Pricing",
  "multiline": false
 },
 "landing.smart_in": {
  "default": "Smart-in",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Smart-in",
  "section": "Tablet",
  "multiline": false
 },
 "landing.14_days_left": {
  "default": "14 days left",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "14 days left",
  "section": "Tablet",
  "multiline": false
 },
 "landing.fresh_mart": {
  "default": "FRESH MART",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "FRESH MART",
  "section": "Tablet",
  "multiline": false
 },
 "landing.total": {
  "default": "TOTAL",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "TOTAL",
  "section": "Tablet",
  "multiline": false
 },
 "landing.charge": {
  "default": "Charge",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Charge",
  "section": "Tablet",
  "multiline": false
 },
 "landing.b_pn_2611_nov_26": {
  "default": "B#PN-2611 · Nov 26",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "B#PN-2611 · Nov 26",
  "section": "Phone",
  "multiline": false
 },
 "landing.omr_3_450": {
  "default": "OMR 3.450",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "OMR 3.450",
  "section": "Phone",
  "multiline": false
 },
 "landing.fefo_picked": {
  "default": "FEFO picked",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "FEFO picked",
  "section": "HeroMockup",
  "multiline": false
 },
 "landing.b_pn_26112_exp_19": {
  "default": "B#PN-26112 · EXP 19 Nov",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "B#PN-26112 · EXP 19 Nov",
  "section": "HeroMockup",
  "multiline": false
 },
 "landing.tapal_tea_190g": {
  "default": "Tapal Tea 190g",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Tapal Tea 190g",
  "section": "TILES",
  "multiline": false
 },
 "landing.milkpak_1l": {
  "default": "Milkpak 1L",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Milkpak 1L",
  "section": "TILES",
  "multiline": false
 },
 "landing.dawn_bread": {
  "default": "Dawn Bread",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Dawn Bread",
  "section": "TILES",
  "multiline": false
 },
 "landing.coca_cola_1_5l": {
  "default": "Coca-Cola 1.5L",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Coca-Cola 1.5L",
  "section": "TILES",
  "multiline": false
 },
 "landing.basmati_1kg": {
  "default": "Basmati 1kg",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Basmati 1kg",
  "section": "TILES",
  "multiline": false
 },
 "landing.lux_soap": {
  "default": "Lux Soap",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Lux Soap",
  "section": "TILES",
  "multiline": false
 },
 "landing.surf_excel": {
  "default": "Surf Excel",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Surf Excel",
  "section": "TILES",
  "multiline": false
 },
 "landing.farm_eggs": {
  "default": "Farm Eggs",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Farm Eggs",
  "section": "TILES",
  "multiline": false
 },
 "landing.lay_s_classic": {
  "default": "Lay's Classic",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Lay's Classic",
  "section": "TILES",
  "multiline": false
 },
 "landing.coca_cola_x3": {
  "default": "Coca-Cola x3",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Coca-Cola x3",
  "section": "Tablet",
  "multiline": false
 },
 "landing.milkpak_x1": {
  "default": "Milkpak x1",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Milkpak x1",
  "section": "Tablet",
  "multiline": false
 },
 "landing.panadol_500mg": {
  "default": "Panadol 500mg",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Panadol 500mg",
  "section": "Phone",
  "multiline": false
 },
 "landing.augmentin_625": {
  "default": "Augmentin 625",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Augmentin 625",
  "section": "Phone",
  "multiline": false
 },
 "landing.brufen_400": {
  "default": "Brufen 400",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Brufen 400",
  "section": "Phone",
  "multiline": false
 },
 "landing.calpol_120ml": {
  "default": "Calpol 120ml",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Calpol 120ml",
  "section": "Phone",
  "multiline": false
 },
 "landing.one_account_three_ways_to": {
  "default": "One account, three ways to sell",
  "required": true,
  "placeholders": [],
  "max_length": 93,
  "kind": "text",
  "page": "Landing",
  "label": "One account, three ways to sell",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.pick_the_counter_you_run": {
  "default": "Pick the counter you run.",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Pick the counter you run.",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.new": {
  "default": "New",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "New",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.from_table_to_kitchen_to": {
  "default": "From table to kitchen to bill, on any screen.",
  "required": true,
  "placeholders": [],
  "max_length": 135,
  "kind": "text",
  "page": "Landing",
  "label": "From table to kitchen to bill, on any screen.",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.restaurant_host_stand_with_a": {
  "default": "Restaurant host stand with a tablet showing the table map and a kitchen ticket printer",
  "required": false,
  "placeholders": [],
  "max_length": 258,
  "kind": "attr",
  "page": "Landing",
  "label": "Restaurant host stand with a tablet showing the table map an…",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.retail_pos": {
  "default": "Retail POS",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Retail POS",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.groceries_convenience_and_general_stores": {
  "default": "Groceries, convenience and general stores",
  "required": true,
  "placeholders": [],
  "max_length": 123,
  "kind": "string",
  "page": "Landing",
  "label": "Groceries, convenience and general stores",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.barcode_scanning_and_quick_add": {
  "default": "Barcode scanning and quick add",
  "required": true,
  "placeholders": [],
  "max_length": 90,
  "kind": "string",
  "page": "Landing",
  "label": "Barcode scanning and quick add",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.multi_branch_stock_and_receipts": {
  "default": "Multi-branch stock and receipts",
  "required": true,
  "placeholders": [],
  "max_length": 93,
  "kind": "string",
  "page": "Landing",
  "label": "Multi-branch stock and receipts",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.returns_credit_notes_offline_selling": {
  "default": "Returns, credit notes, offline selling",
  "required": true,
  "placeholders": [],
  "max_length": 114,
  "kind": "string",
  "page": "Landing",
  "label": "Returns, credit notes, offline selling",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.medical_stores_and_chemists": {
  "default": "Medical stores and chemists",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "Landing",
  "label": "Medical stores and chemists",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.batches_and_expiry_dates": {
  "default": "Batches and expiry dates",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Batches and expiry dates",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.automatic_fefo_expired_stock_can": {
  "default": "Automatic FEFO: expired stock can't be sold",
  "required": true,
  "placeholders": [],
  "max_length": 129,
  "kind": "string",
  "page": "Landing",
  "label": "Automatic FEFO: expired stock can't be sold",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.goods_receiving_with_lot_costs": {
  "default": "Goods receiving with lot costs",
  "required": true,
  "placeholders": [],
  "max_length": 90,
  "kind": "string",
  "page": "Landing",
  "label": "Goods receiving with lot costs",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.dine_in_takeaway_and_delivery": {
  "default": "Dine-in, takeaway and delivery",
  "required": true,
  "placeholders": [],
  "max_length": 90,
  "kind": "string",
  "page": "Landing",
  "label": "Dine-in, takeaway and delivery",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.live_table_map_and_kots": {
  "default": "Live table map and KOTs to the kitchen",
  "required": true,
  "placeholders": [],
  "max_length": 114,
  "kind": "string",
  "page": "Landing",
  "label": "Live table map and KOTs to the kitchen",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.kitchen_view_with_timers_and": {
  "default": "Kitchen view with timers and sound",
  "required": true,
  "placeholders": [],
  "max_length": 102,
  "kind": "string",
  "page": "Landing",
  "label": "Kitchen view with timers and sound",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.reservations_split_staff_roles_online": {
  "default": "Reservations, split staff roles, online ordering add-on",
  "required": true,
  "placeholders": [],
  "max_length": 165,
  "kind": "string",
  "page": "Landing",
  "label": "Reservations, split staff roles, online ordering add-on",
  "section": "PRODUCTS",
  "multiline": false
 },
 "landing.live_table_map": {
  "default": "Live table map",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Live table map",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.available_occupied_and_reserved_at": {
  "default": "Available, occupied and reserved at a glance. Waiters open a table from their phone.",
  "required": false,
  "placeholders": [],
  "max_length": 252,
  "kind": "string",
  "page": "Landing",
  "label": "Available, occupied and reserved at a glance. Waiters open a…",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.kots_and_kitchen_view": {
  "default": "KOTs and kitchen view",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "KOTs and kitchen view",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.only_new_items_go_to": {
  "default": "Only new items go to the kitchen. New, In progress and Ready with timers and a sound.",
  "required": false,
  "placeholders": [],
  "max_length": 255,
  "kind": "string",
  "page": "Landing",
  "label": "Only new items go to the kitchen. New, In progress and Ready…",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.reservations": {
  "default": "Reservations",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Reservations",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.no_double_bookings_party_size": {
  "default": "No double bookings, party size checked against seats, Seat opens the order.",
  "required": false,
  "placeholders": [],
  "max_length": 225,
  "kind": "string",
  "page": "Landing",
  "label": "No double bookings, party size checked against seats, Seat o…",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.your_menu_online_by_category_2": {
  "default": "Your menu online by category with delivery or pickup. Orders join the kitchen queue.",
  "required": false,
  "placeholders": [],
  "max_length": 252,
  "kind": "string",
  "page": "Landing",
  "label": "Your menu online by category with delivery or pickup. Orders…",
  "section": "ProductsSection",
  "multiline": false
 },
 "landing.online_store_sell_beyond_the": {
  "default": "Online Store — sell beyond the counter",
  "required": true,
  "placeholders": [],
  "max_length": 114,
  "kind": "text",
  "page": "Landing",
  "label": "Online Store — sell beyond the counter",
  "section": "OnlineStoreSection",
  "multiline": false
 },
 "landing.publish_your_products_to_a": {
  "default": "Publish your products to a mobile shop in minutes. Customers order from their phone, you accept on the POS, and every completed order prints a normal receipt. Included in Growth, Business and Enterprise.",
  "required": false,
  "placeholders": [],
  "max_length": 609,
  "kind": "text",
  "page": "Landing",
  "label": "Publish your products to a mobile shop in minutes. Customers…",
  "section": "OnlineStoreSection",
  "multiline": true
 },
 "landing.see_a_live_demo_store": {
  "default": "See a live demo store",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "See a live demo store",
  "section": "OnlineStoreSection",
  "multiline": false
 },
 "landing.smart_in_online_store": {
  "default": "Smart-in Online Store",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Smart-in Online Store",
  "section": "OnlineStoreSection",
  "multiline": false
 },
 "landing.karachi_fresh_mart_online_store": {
  "default": "Karachi Fresh Mart online store on a phone",
  "required": true,
  "placeholders": [],
  "max_length": 126,
  "kind": "attr",
  "page": "Landing",
  "label": "Karachi Fresh Mart online store on a phone",
  "section": "OnlineStoreSection",
  "multiline": false
 },
 "landing.your_own_store_link": {
  "default": "Your own store link",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Your own store link",
  "section": "POINTS",
  "multiline": false
 },
 "landing.share_it_on_whatsapp_or": {
  "default": "Share it on WhatsApp or print the QR code for your counter.",
  "required": true,
  "placeholders": [],
  "max_length": 177,
  "kind": "string",
  "page": "Landing",
  "label": "Share it on WhatsApp or print the QR code for your counter.",
  "section": "POINTS",
  "multiline": false
 },
 "landing.delivery_areas_pickup": {
  "default": "Delivery areas & pickup",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Delivery areas & pickup",
  "section": "POINTS",
  "multiline": false
 },
 "landing.set_a_fee_per_area": {
  "default": "Set a fee per area and a minimum order, or let customers collect.",
  "required": false,
  "placeholders": [],
  "max_length": 195,
  "kind": "string",
  "page": "Landing",
  "label": "Set a fee per area and a minimum order, or let customers col…",
  "section": "POINTS",
  "multiline": false
 },
 "landing.cash_on_delivery": {
  "default": "Cash on delivery",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Cash on delivery",
  "section": "POINTS",
  "multiline": false
 },
 "landing.no_payment_setup_customers_pay": {
  "default": "No payment setup. Customers pay on delivery or at pickup.",
  "required": true,
  "placeholders": [],
  "max_length": 171,
  "kind": "string",
  "page": "Landing",
  "label": "No payment setup. Customers pay on delivery or at pickup.",
  "section": "POINTS",
  "multiline": false
 },
 "landing.orders_become_sales": {
  "default": "Orders become sales",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Orders become sales",
  "section": "POINTS",
  "multiline": false
 },
 "landing.complete_an_order_and_it": {
  "default": "Complete an order and it's a normal receipt with stock deducted.",
  "required": false,
  "placeholders": [],
  "max_length": 192,
  "kind": "string",
  "page": "Landing",
  "label": "Complete an order and it's a normal receipt with stock deduc…",
  "section": "POINTS",
  "multiline": false
 },
 "landing.sales_and_profit_reports_that": {
  "default": "Sales and profit reports that answer “how did we do?”",
  "required": true,
  "placeholders": [],
  "max_length": 159,
  "kind": "text",
  "page": "Landing",
  "label": "Sales and profit reports that answer “how did we do?”",
  "section": "ReportsSection",
  "multiline": false
 },
 "landing.daily_weekly_monthly": {
  "default": "Daily, weekly, monthly",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Daily, weekly, monthly",
  "section": "POINTS",
  "multiline": false
 },
 "landing.today_last_7_days_this": {
  "default": "Today, last 7 days, this month or any range up to a year.",
  "required": true,
  "placeholders": [],
  "max_length": 171,
  "kind": "string",
  "page": "Landing",
  "label": "Today, last 7 days, this month or any range up to a year.",
  "section": "POINTS",
  "multiline": false
 },
 "landing.every_branch_or_one": {
  "default": "Every branch or one",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Every branch or one",
  "section": "POINTS",
  "multiline": false
 },
 "landing.compare_branches_managers_only_see": {
  "default": "Compare branches; managers only see the branches they work in.",
  "required": false,
  "placeholders": [],
  "max_length": 186,
  "kind": "string",
  "page": "Landing",
  "label": "Compare branches; managers only see the branches they work i…",
  "section": "POINTS",
  "multiline": false
 },
 "landing.net_revenue_at_a_glance": {
  "default": "Net revenue at a glance",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Net revenue at a glance",
  "section": "POINTS",
  "multiline": false
 },
 "landing.gross_sales_discounts_returns_net": {
  "default": "Gross sales, discounts, returns, net, tax, sale count and average sale.",
  "required": false,
  "placeholders": [],
  "max_length": 213,
  "kind": "string",
  "page": "Landing",
  "label": "Gross sales, discounts, returns, net, tax, sale count and av…",
  "section": "POINTS",
  "multiline": false
 },
 "landing.export_to_csv": {
  "default": "Export to CSV",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Export to CSV",
  "section": "POINTS",
  "multiline": false
 },
 "landing.send_the_table_to_your": {
  "default": "Send the table to your accountant or open it in Excel.",
  "required": true,
  "placeholders": [],
  "max_length": 162,
  "kind": "string",
  "page": "Landing",
  "label": "Send the table to your accountant or open it in Excel.",
  "section": "POINTS",
  "multiline": false
 },
 "landing.reseller_program": {
  "default": "Reseller program",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Reseller program",
  "section": "ResellerSection",
  "multiline": false
 },
 "landing.bring_shops_to_smart_in": {
  "default": "Bring shops to Smart-in. Earn 20% of what they pay.",
  "required": true,
  "placeholders": [],
  "max_length": 153,
  "kind": "text",
  "page": "Landing",
  "label": "Bring shops to Smart-in. Earn 20% of what they pay.",
  "section": "ResellerSection",
  "multiline": false
 },
 "landing.for_it_shops_pos_installers": {
  "default": "For IT shops, POS installers and consultants who already work with retailers and pharmacies. No fee to join.",
  "required": false,
  "placeholders": [],
  "max_length": 324,
  "kind": "text",
  "page": "Landing",
  "label": "For IT shops, POS installers and consultants who already wor…",
  "section": "ResellerSection",
  "multiline": false
 },
 "landing.apply": {
  "default": "Apply",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Apply",
  "section": "STEPS",
  "multiline": false
 },
 "landing.tell_us_who_you_are": {
  "default": "Tell us who you are and how you will sell. We review every application and approve you with your own referral code.",
  "required": false,
  "placeholders": [],
  "max_length": 345,
  "kind": "string",
  "page": "Landing",
  "label": "Tell us who you are and how you will sell. We review every a…",
  "section": "STEPS",
  "multiline": false
 },
 "landing.share_your_link": {
  "default": "Share your link",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Share your link",
  "section": "STEPS",
  "multiline": false
 },
 "landing.shops_that_sign_up_through": {
  "default": "Shops that sign up through your link or enter your code are linked to you, and you can follow every one in your reseller portal.",
  "required": false,
  "placeholders": [],
  "max_length": 384,
  "kind": "string",
  "page": "Landing",
  "label": "Shops that sign up through your link or enter your code are …",
  "section": "STEPS",
  "multiline": true
 },
 "landing.earn_20": {
  "default": "Earn 20%",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Earn 20%",
  "section": "STEPS",
  "multiline": false
 },
 "landing.you_earn_20_of_each": {
  "default": "You earn 20% of each subscription payment they make, in the currency they pay in. Your statement shows earned, paid and balance.",
  "required": false,
  "placeholders": [],
  "max_length": 384,
  "kind": "string",
  "page": "Landing",
  "label": "You earn 20% of each subscription payment they make, in the …",
  "section": "STEPS",
  "multiline": true
 },
 "landing.most_popular": {
  "default": "Most popular",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Most popular",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.custom": {
  "default": "Custom",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Custom",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.sales_reports": {
  "default": "Sales reports",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Sales reports",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.contact_sales": {
  "default": "Contact sales",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Contact sales",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.request_received": {
  "default": "Request received",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Request received",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.request_upgrade": {
  "default": "Request upgrade",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Request upgrade",
  "section": "PlanCards",
  "multiline": false
 },
 "landing.optional_extra": {
  "default": "Optional extra",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "Optional extra",
  "section": "AddonCard",
  "multiline": false
 },
 "landing.month": {
  "default": "/month",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Landing",
  "label": "/month",
  "section": "AddonCard",
  "multiline": false
 },
 "how.prev": {
  "default": "Prev",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "How it works",
  "label": "Prev",
  "section": "Lightbox",
  "multiline": false
 },
 "how.next": {
  "default": "Next",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "How it works",
  "label": "Next",
  "section": "Lightbox",
  "multiline": false
 },
 "how.how_it_works": {
  "default": "How it works",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "How it works",
  "label": "How it works",
  "section": "HowItWorks",
  "multiline": false
 },
 "how.every_screen_exactly_as_your": {
  "default": "Every screen, exactly as your cashier sees it.",
  "required": true,
  "placeholders": [],
  "max_length": 138,
  "kind": "text",
  "page": "How it works",
  "label": "Every screen, exactly as your cashier sees it.",
  "section": "HowItWorks",
  "multiline": false
 },
 "how.real_screenshots_from_the_live": {
  "default": "Real screenshots from the live app using the demo accounts. Tap any image to enlarge it.",
  "required": false,
  "placeholders": [],
  "max_length": 264,
  "kind": "text",
  "page": "How it works",
  "label": "Real screenshots from the live app using the demo accounts. …",
  "section": "HowItWorks",
  "multiline": false
 },
 "how.loading_walkthrough": {
  "default": "Loading walkthrough…",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "How it works",
  "label": "Loading walkthrough…",
  "section": "HowItWorks",
  "multiline": false
 },
 "how.sign_up_in_a_minute": {
  "default": "Sign up in a minute",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Sign up in a minute",
  "section": "GROUPS",
  "multiline": false
 },
 "how.no_card_no_install_your": {
  "default": "No card, no install. Your country, currency and tax are set for you.",
  "required": false,
  "placeholders": [],
  "max_length": 204,
  "kind": "string",
  "page": "How it works",
  "label": "No card, no install. Your country, currency and tax are set …",
  "section": "GROUPS",
  "multiline": false
 },
 "how.sell_on_any_screen": {
  "default": "Sell on any screen",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Sell on any screen",
  "section": "GROUPS",
  "multiline": false
 },
 "how.counter_pc_tablet_or_the": {
  "default": "Counter PC, tablet or the phone in your pocket. Barcode scanners work straight away.",
  "required": false,
  "placeholders": [],
  "max_length": 252,
  "kind": "string",
  "page": "How it works",
  "label": "Counter PC, tablet or the phone in your pocket. Barcode scan…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.discounts_and_payment": {
  "default": "Discounts and payment",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Discounts and payment",
  "section": "GROUPS",
  "multiline": false
 },
 "how.line_and_cart_discounts_cash": {
  "default": "Line and cart discounts, cash with change or card. Tax stays exact.",
  "required": false,
  "placeholders": [],
  "max_length": 201,
  "kind": "string",
  "page": "How it works",
  "label": "Line and cart discounts, cash with change or card. Tax stays…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.thermal_receipts": {
  "default": "Thermal receipts",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Thermal receipts",
  "section": "GROUPS",
  "multiline": false
 },
 "how.58mm_or_80mm_printed_from": {
  "default": "58mm or 80mm, printed from the browser or directly over USB or Bluetooth.",
  "required": false,
  "placeholders": [],
  "max_length": 219,
  "kind": "string",
  "page": "How it works",
  "label": "58mm or 80mm, printed from the browser or directly over USB …",
  "section": "GROUPS",
  "multiline": false
 },
 "how.restaurant_tables_to_kitchen": {
  "default": "Restaurant: tables to kitchen",
  "required": true,
  "placeholders": [],
  "max_length": 87,
  "kind": "string",
  "page": "How it works",
  "label": "Restaurant: tables to kitchen",
  "section": "GROUPS",
  "multiline": false
 },
 "how.live_table_map_orders_from": {
  "default": "Live table map, orders from a phone, KOTs that send only new items, and a kitchen view with New, In progress and Ready.",
  "required": false,
  "placeholders": [],
  "max_length": 357,
  "kind": "string",
  "page": "How it works",
  "label": "Live table map, orders from a phone, KOTs that send only new…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.restaurant_bill_book_and_order": {
  "default": "Restaurant: bill, book and order online",
  "required": true,
  "placeholders": [],
  "max_length": 117,
  "kind": "string",
  "page": "How it works",
  "label": "Restaurant: bill, book and order online",
  "section": "GROUPS",
  "multiline": false
 },
 "how.bill_with_discounts_and_free": {
  "default": "Bill with discounts and free the table, take reservations without double bookings, and run the Online Ordering add-on queue.",
  "required": false,
  "placeholders": [],
  "max_length": 372,
  "kind": "string",
  "page": "How it works",
  "label": "Bill with discounts and free the table, take reservations wi…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.pharmacy_fefo": {
  "default": "Pharmacy FEFO",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Pharmacy FEFO",
  "section": "GROUPS",
  "multiline": false
 },
 "how.the_earliest_expiring_valid_batch": {
  "default": "The earliest-expiring valid batch is used every time. Expired stock can't be sold.",
  "required": false,
  "placeholders": [],
  "max_length": 246,
  "kind": "string",
  "page": "How it works",
  "label": "The earliest-expiring valid batch is used every time. Expire…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.online_store_premium": {
  "default": "Online Store (Premium)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Online Store (Premium)",
  "section": "GROUPS",
  "multiline": false
 },
 "how.your_own_mobile_shop_customers": {
  "default": "Your own mobile shop: customers add to cart, check out with cash on delivery or pickup and track the order. You set it up, accept orders and complete them as normal sales.",
  "required": false,
  "placeholders": [],
  "max_length": 513,
  "kind": "string",
  "page": "How it works",
  "label": "Your own mobile shop: customers add to cart, check out with …",
  "section": "GROUPS",
  "multiline": true
 },
 "how.sales_reports_premium": {
  "default": "Sales reports (Premium)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Sales reports (Premium)",
  "section": "GROUPS",
  "multiline": false
 },
 "how.pick_a_date_range_group": {
  "default": "Pick a date range, group by day, week or month and filter by branch. Totals, a chart, the payment split and a table you can export to CSV.",
  "required": false,
  "placeholders": [],
  "max_length": 414,
  "kind": "string",
  "page": "How it works",
  "label": "Pick a date range, group by day, week or month and filter by…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.profit_loss_premium": {
  "default": "Profit & Loss (Premium)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Profit & Loss (Premium)",
  "section": "GROUPS",
  "multiline": false
 },
 "how.every_sale_line_keeps_its": {
  "default": "Every sale line keeps its cost from the goods you received (or the product Cost price). See revenue excluding tax, cost of goods, gross profit, margin and the top 10 products by profit, with a chart and CSV.",
  "required": false,
  "placeholders": [],
  "max_length": 621,
  "kind": "string",
  "page": "How it works",
  "label": "Every sale line keeps its cost from the goods you received (…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.returns_credit_notes": {
  "default": "Returns & credit notes",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Returns & credit notes",
  "section": "GROUPS",
  "multiline": false
 },
 "how.scan_the_receipt_barcode_return": {
  "default": "Scan the receipt barcode, return items as resellable or damaged, and refund in cash or with a credit note the customer spends on their next visit.",
  "required": false,
  "placeholders": [],
  "max_length": 438,
  "kind": "string",
  "page": "How it works",
  "label": "Scan the receipt barcode, return items as resellable or dama…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.scan_with_your_phone_camera": {
  "default": "Scan with your phone camera",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "How it works",
  "label": "Scan with your phone camera",
  "section": "GROUPS",
  "multiline": false
 },
 "how.tap_the_camera_next_to": {
  "default": "Tap the camera next to search and point it at a barcode: beep, vibrate, added to the cart. Works offline too.",
  "required": false,
  "placeholders": [],
  "max_length": 327,
  "kind": "string",
  "page": "How it works",
  "label": "Tap the camera next to search and point it at a barcode: bee…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.worldwide_countries_tax": {
  "default": "Worldwide countries & tax",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Worldwide countries & tax",
  "section": "GROUPS",
  "multiline": false
 },
 "how.every_country_with_its_currency": {
  "default": "Every country with its currency, decimals and standard tax. The USA and Canada add a state or province step, and you can edit the rate.",
  "required": false,
  "placeholders": [],
  "max_length": 405,
  "kind": "string",
  "page": "How it works",
  "label": "Every country with its currency, decimals and standard tax. …",
  "section": "GROUPS",
  "multiline": true
 },
 "how.reseller_program": {
  "default": "Reseller program",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Reseller program",
  "section": "GROUPS",
  "multiline": false
 },
 "how.resellers_share_a_referral_link": {
  "default": "Resellers share a referral link, earn 20% of their shops' subscription payments and follow everything in their own portal.",
  "required": false,
  "placeholders": [],
  "max_length": 366,
  "kind": "string",
  "page": "How it works",
  "label": "Resellers share a referral link, earn 20% of their shops' su…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.goods_receiving_shelves": {
  "default": "Goods Receiving & shelves",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Goods Receiving & shelves",
  "section": "GROUPS",
  "multiline": false
 },
 "how.optional_inventory_add_on_receive": {
  "default": "Optional Inventory add-on: receive goods with a GRN, put them away to shelf locations and see where to pick on every cart line.",
  "required": false,
  "placeholders": [],
  "max_length": 381,
  "kind": "string",
  "page": "How it works",
  "label": "Optional Inventory add-on: receive goods with a GRN, put the…",
  "section": "GROUPS",
  "multiline": true
 },
 "how.products_and_sales_history": {
  "default": "Products and sales history",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Products and sales history",
  "section": "GROUPS",
  "multiline": false
 },
 "how.quick_add_products_and_reprint": {
  "default": "Quick-add products and reprint any receipt.",
  "required": true,
  "placeholders": [],
  "max_length": 129,
  "kind": "string",
  "page": "How it works",
  "label": "Quick-add products and reprint any receipt.",
  "section": "GROUPS",
  "multiline": false
 },
 "how.settings_branches_and_team": {
  "default": "Settings, branches and team",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "How it works",
  "label": "Settings, branches and team",
  "section": "GROUPS",
  "multiline": false
 },
 "how.tax_by_country_printer_setup": {
  "default": "Tax by country, printer setup, branches, staff and role permissions.",
  "required": false,
  "placeholders": [],
  "max_length": 204,
  "kind": "string",
  "page": "How it works",
  "label": "Tax by country, printer setup, branches, staff and role perm…",
  "section": "GROUPS",
  "multiline": false
 },
 "how.demo_and_upgrade": {
  "default": "Demo and upgrade",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "How it works",
  "label": "Demo and upgrade",
  "section": "GROUPS",
  "multiline": false
 },
 "how.15_days_free_a_clear": {
  "default": "15 days free, a clear countdown, and your data is kept when you upgrade.",
  "required": false,
  "placeholders": [],
  "max_length": 216,
  "kind": "string",
  "page": "How it works",
  "label": "15 days free, a clear countdown, and your data is kept when …",
  "section": "GROUPS",
  "multiline": false
 },
 "contact.contact": {
  "default": "Contact",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Contact",
  "label": "Contact",
  "section": "Contact",
  "multiline": false
 },
 "contact.talk_to_the_smart_in": {
  "default": "Talk to the Smart-in team",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Contact",
  "label": "Talk to the Smart-in team",
  "section": "Contact",
  "multiline": false
 },
 "contact.questions_about_your_counter_a": {
  "default": "Questions about your counter, a plan for several branches, or help with a printer or scanner. Send us a note and we'll get back to you shortly.",
  "required": false,
  "placeholders": [],
  "max_length": 429,
  "kind": "text",
  "page": "Contact",
  "label": "Questions about your counter, a plan for several branches, o…",
  "section": "Contact",
  "multiline": true
 },
 "contact.enquiry_type": {
  "default": "Enquiry type",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Enquiry type",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.business_name": {
  "default": "Business name",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Business name",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.contact_person": {
  "default": "Contact person",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Contact person",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.mobile": {
  "default": "Mobile",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Mobile",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.email": {
  "default": "Email",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Email",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.write_to_us": {
  "default": "Write to us",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Contact",
  "label": "Write to us",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.this_field_is_required": {
  "default": "This field is required",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Contact",
  "label": "This field is required",
  "section": "REQ",
  "multiline": false
 },
 "contact.enter_a_valid_email": {
  "default": "Enter a valid email",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Contact",
  "label": "Enter a valid email",
  "section": "Field error messages",
  "multiline": false
 },
 "contact.enter_a_valid_mobile_number": {
  "default": "Enter a valid mobile number",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "Contact",
  "label": "Enter a valid mobile number",
  "section": "Field error messages",
  "multiline": false
 },
 "contact.support": {
  "default": "Support",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Contact",
  "label": "Support",
  "section": "ContactForm",
  "multiline": false
 },
 "contact.sales": {
  "default": "Sales",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Contact",
  "label": "Sales",
  "section": "ContactForm",
  "multiline": false
 },
 "reseller.reseller_login": {
  "default": "Reseller login",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Reseller login",
  "section": "Login",
  "multiline": false
 },
 "reseller.separate_from_shop_owner_and": {
  "default": "Separate from shop owner and admin accounts.",
  "required": true,
  "placeholders": [],
  "max_length": 132,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Separate from shop owner and admin accounts.",
  "section": "Login",
  "multiline": false
 },
 "reseller.not_a_reseller_yet_apply": {
  "default": "Not a reseller yet? Apply",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Not a reseller yet? Apply",
  "section": "Login",
  "multiline": false
 },
 "reseller.your_referral_link": {
  "default": "Your referral link",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Your referral link",
  "section": "Performance",
  "multiline": false
 },
 "reseller.copy": {
  "default": "Copy",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Copy",
  "section": "Performance",
  "multiline": false
 },
 "reseller.code": {
  "default": "Code",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Code",
  "section": "Performance",
  "multiline": false
 },
 "reseller.no_referred_businesses_yet_share": {
  "default": "No referred businesses yet. Share your link to get started.",
  "required": true,
  "placeholders": [],
  "max_length": 177,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "No referred businesses yet. Share your link to get started.",
  "section": "Businesses",
  "multiline": false
 },
 "reseller.from": {
  "default": "From",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "From",
  "section": "Statement",
  "multiline": false
 },
 "reseller.to": {
  "default": "To",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "To",
  "section": "Statement",
  "multiline": false
 },
 "reseller.download_statement_pdf": {
  "default": "Download statement PDF",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Download statement PDF",
  "section": "Statement",
  "multiline": false
 },
 "reseller.csv": {
  "default": "CSV",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "CSV",
  "section": "Statement",
  "multiline": false
 },
 "reseller.date": {
  "default": "Date",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Date",
  "section": "Statement",
  "multiline": false
 },
 "reseller.details": {
  "default": "Details",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Details",
  "section": "Statement",
  "multiline": false
 },
 "reseller.earned": {
  "default": "Earned",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Earned",
  "section": "Statement",
  "multiline": false
 },
 "reseller.paid": {
  "default": "Paid",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Paid",
  "section": "Statement",
  "multiline": false
 },
 "reseller.balance": {
  "default": "Balance",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Balance",
  "section": "Performance",
  "multiline": false
 },
 "reseller.payout": {
  "default": "Payout",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Payout",
  "section": "Statement",
  "multiline": false
 },
 "reseller.no_entries_in_this_range": {
  "default": "No entries in this range",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "No entries in this range",
  "section": "Statement",
  "multiline": false
 },
 "reseller.reseller": {
  "default": "Reseller",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Become a Reseller",
  "label": "Reseller",
  "section": "Reseller",
  "multiline": false
 },
 "reseller.email": {
  "default": "Email",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Email",
  "section": "Login",
  "multiline": false
 },
 "reseller.password": {
  "default": "Password",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Password",
  "section": "Login",
  "multiline": false
 },
 "reseller.referred": {
  "default": "Referred",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Referred",
  "section": "Performance",
  "multiline": false
 },
 "reseller.in_demo": {
  "default": "In demo",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "In demo",
  "section": "Performance",
  "multiline": false
 },
 "reseller.paying": {
  "default": "Paying",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Paying",
  "section": "Performance",
  "multiline": false
 },
 "reseller.expired": {
  "default": "Expired",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Expired",
  "section": "Performance",
  "multiline": false
 },
 "reseller.conversion": {
  "default": "Conversion",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Conversion",
  "section": "Performance",
  "multiline": false
 },
 "reseller.earned_this_month": {
  "default": "Earned this month",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Earned this month",
  "section": "Performance",
  "multiline": false
 },
 "reseller.earned_all_time": {
  "default": "Earned all time",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Earned all time",
  "section": "Performance",
  "multiline": false
 },
 "reseller.log_out": {
  "default": "Log out",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Become a Reseller",
  "label": "Log out",
  "section": "Reseller",
  "multiline": false
 },
 "reseller.referral_link_copied": {
  "default": "Referral link copied",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Referral link copied",
  "section": "Performance",
  "multiline": false
 },
 "reseller.recurring": {
  "default": "Recurring",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Recurring",
  "section": "Performance",
  "multiline": false
 },
 "reseller.performance": {
  "default": "Performance",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Performance",
  "section": "TABS",
  "multiline": false
 },
 "reseller.businesses": {
  "default": "Businesses",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Businesses",
  "section": "TABS",
  "multiline": false
 },
 "reseller.statement": {
  "default": "Statement",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Statement",
  "section": "TABS",
  "multiline": false
 },
 "login.email_or_username": {
  "default": "Email or username",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Email or username",
  "section": "Login",
  "multiline": false
 },
 "login.password": {
  "default": "Password",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Password",
  "section": "Login",
  "multiline": false
 },
 "login.new_shop": {
  "default": "New shop?",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "New shop?",
  "section": "Login",
  "multiline": false
 },
 "login.start_a_15_day_demo": {
  "default": "Start a 15-day demo",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Start a 15-day demo",
  "section": "Login",
  "multiline": false
 },
 "login.back_to_the_counter": {
  "default": "Back to the counter",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Login",
  "label": "Back to the counter",
  "section": "Login",
  "multiline": false
 },
 "login.owner_shop_com_or_staff": {
  "default": "owner@shop.com or staff username",
  "required": true,
  "placeholders": [],
  "max_length": 96,
  "kind": "attr",
  "page": "Login",
  "label": "owner@shop.com or staff username",
  "section": "Login",
  "multiline": false
 },
 "login.owners_use_their_email_staff": {
  "default": "Owners use their email. Staff use the username the owner gave them.",
  "required": false,
  "placeholders": [],
  "max_length": 201,
  "kind": "string",
  "page": "Login",
  "label": "Owners use their email. Staff use the username the owner gav…",
  "section": "Login",
  "multiline": false
 },
 "login.cloud_point_of_sale": {
  "default": "Cloud point of sale",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Cloud point of sale",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.ring_up_the_first_sale": {
  "default": "Ring up the first sale",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Ring up the first sale",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.before_the_kettle_boils": {
  "default": "before the kettle boils.",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "before the kettle boils.",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.scanner_ready_thermal_printer_ready": {
  "default": "Scanner-ready, thermal-printer-ready and FEFO-aware for pharmacies. Works on the phone in your pocket or the counter PC.",
  "required": false,
  "placeholders": [],
  "max_length": 360,
  "kind": "text",
  "page": "Login",
  "label": "Scanner-ready, thermal-printer-ready and FEFO-aware for phar…",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.karachi_fresh_mart": {
  "default": "KARACHI FRESH MART",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "KARACHI FRESH MART",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.main_000128_14_02": {
  "default": "MAIN-000128 · 14:02",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "MAIN-000128 · 14:02",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.total_pkr": {
  "default": "TOTAL PKR",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "TOTAL PKR",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.sales_tax_18_incl": {
  "default": "Sales Tax 18% (incl.)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Login",
  "label": "Sales Tax 18% (incl.)",
  "section": "AuthLayout",
  "multiline": false
 },
 "login.panadol_500mg_x20": {
  "default": "Panadol 500mg x20",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "Panadol 500mg x20",
  "section": "TAPE",
  "multiline": false
 },
 "login.2_x_0_150": {
  "default": "2 x 0.150",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "2 x 0.150",
  "section": "TAPE",
  "multiline": false
 },
 "login.b_pn_26094_exp_12": {
  "default": "B# PN-26094  EXP 12 Nov",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "B# PN-26094  EXP 12 Nov",
  "section": "TAPE",
  "multiline": false
 },
 "login.basmati_rice_1kg": {
  "default": "Basmati Rice 1kg",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "Basmati Rice 1kg",
  "section": "TAPE",
  "multiline": false
 },
 "login.1_x_420_00": {
  "default": "1 x 420.00",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "1 x 420.00",
  "section": "TAPE",
  "multiline": false
 },
 "login.coca_cola_1_5l": {
  "default": "Coca-Cola 1.5L",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "Coca-Cola 1.5L",
  "section": "TAPE",
  "multiline": false
 },
 "login.3_x_220_00": {
  "default": "3 x 220.00",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Login",
  "label": "3 x 220.00",
  "section": "TAPE",
  "multiline": false
 },
 "signup.change_later_in_settings": {
  "default": "(change later in Settings)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "(change later in Settings)",
  "section": "LocationBlock",
  "multiline": false
 },
 "signup.business_name": {
  "default": "Business name",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Business name",
  "section": "Signup",
  "multiline": false
 },
 "signup.business_type": {
  "default": "Business type",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Business type",
  "section": "Signup",
  "multiline": false
 },
 "signup.owner_email": {
  "default": "Owner email",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Owner email",
  "section": "Signup",
  "multiline": false
 },
 "signup.password": {
  "default": "Password",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Password",
  "section": "Signup",
  "multiline": false
 },
 "signup.referral_code": {
  "default": "Referral code",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Referral code",
  "section": "Signup",
  "multiline": false
 },
 "signup.optional": {
  "default": "(optional)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "(optional)",
  "section": "Signup",
  "multiline": false
 },
 "signup.referral_code_not_found": {
  "default": "Referral code not found",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Referral code not found",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.referral_code_applied": {
  "default": "Referral code applied",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Referral code applied",
  "section": "Signup",
  "multiline": false
 },
 "signup.already_have_an_account": {
  "default": "Already have an account?",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Already have an account?",
  "section": "Signup",
  "multiline": false
 },
 "signup.log_in": {
  "default": "Log in",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Signup",
  "label": "Log in",
  "section": "Signup",
  "multiline": false
 },
 "signup.open_your_register": {
  "default": "Open your register",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Signup",
  "label": "Open your register",
  "section": "Signup",
  "multiline": false
 },
 "signup.e_g_test_mart": {
  "default": "e.g. Test Mart",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Signup",
  "label": "e.g. Test Mart",
  "section": "Signup",
  "multiline": false
 },
 "signup.you_shop_com": {
  "default": "you@shop.com",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Signup",
  "label": "you@shop.com",
  "section": "Signup",
  "multiline": false
 },
 "signup.at_least_6_characters": {
  "default": "At least 6 characters",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Signup",
  "label": "At least 6 characters",
  "section": "Signup",
  "multiline": false
 },
 "signup.e_g_smart20": {
  "default": "e.g. SMART20",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Signup",
  "label": "e.g. SMART20",
  "section": "Signup",
  "multiline": false
 },
 "signup.general_retail": {
  "default": "General Retail",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "General Retail",
  "section": "TYPES",
  "multiline": false
 },
 "signup.groceries_household_convenience": {
  "default": "Groceries, household, convenience",
  "required": true,
  "placeholders": [],
  "max_length": 99,
  "kind": "string",
  "page": "Signup",
  "label": "Groceries, household, convenience",
  "section": "TYPES",
  "multiline": false
 },
 "signup.pharmacy_medical_store": {
  "default": "Pharmacy / Medical Store",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Pharmacy / Medical Store",
  "section": "TYPES",
  "multiline": false
 },
 "signup.batches_expiry_automatic_fefo": {
  "default": "Batches, expiry & automatic FEFO",
  "required": true,
  "placeholders": [],
  "max_length": 96,
  "kind": "string",
  "page": "Signup",
  "label": "Batches, expiry & automatic FEFO",
  "section": "TYPES",
  "multiline": false
 },
 "signup.restaurant": {
  "default": "Restaurant",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Restaurant",
  "section": "TYPES",
  "multiline": false
 },
 "signup.tables_kots_kitchen_view_billing": {
  "default": "Tables, KOTs, kitchen view & billing",
  "required": true,
  "placeholders": [],
  "max_length": 108,
  "kind": "string",
  "page": "Signup",
  "label": "Tables, KOTs, kitchen view & billing",
  "section": "TYPES",
  "multiline": false
 },
 "signup.enter_your_business_name": {
  "default": "Enter your business name",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Enter your business name",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.business_name_must_be_120": {
  "default": "Business name must be 120 characters or fewer",
  "required": true,
  "placeholders": [],
  "max_length": 135,
  "kind": "string",
  "page": "Signup",
  "label": "Business name must be 120 characters or fewer",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.choose_your_business_type": {
  "default": "Choose your business type",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Choose your business type",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.enter_your_email_address": {
  "default": "Enter your email address",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Enter your email address",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.enter_a_valid_email_address": {
  "default": "Enter a valid email address",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "Signup",
  "label": "Enter a valid email address",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.enter_a_password": {
  "default": "Enter a password",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Enter a password",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.password_must_be_at_least": {
  "default": "Password must be at least 6 characters",
  "required": true,
  "placeholders": [],
  "max_length": 114,
  "kind": "string",
  "page": "Signup",
  "label": "Password must be at least 6 characters",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.password_must_be_128_characters": {
  "default": "Password must be 128 characters or fewer",
  "required": true,
  "placeholders": [],
  "max_length": 120,
  "kind": "string",
  "page": "Signup",
  "label": "Password must be 128 characters or fewer",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.select_your_country": {
  "default": "Select your country",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Select your country",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.referral_codes_use_letters_numbers": {
  "default": "Referral codes use letters, numbers, - or _ (2–40 characters)",
  "required": false,
  "placeholders": [],
  "max_length": 183,
  "kind": "string",
  "page": "Signup",
  "label": "Referral codes use letters, numbers, - or _ (2–40 characters…",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.detecting_your_country": {
  "default": "Detecting your country…",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Detecting your country…",
  "section": "LocationBlock",
  "multiline": false
 },
 "signup.four_fields_sample_products_are": {
  "default": "Four fields. Sample products are loaded so you can sell right away.",
  "required": false,
  "placeholders": [],
  "max_length": 201,
  "kind": "string",
  "page": "Signup",
  "label": "Four fields. Sample products are loaded so you can sell righ…",
  "section": "Signup",
  "multiline": false
 },
 "upgrade.account_locked": {
  "default": "Account locked",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Upgrade / demo locked",
  "label": "Account locked",
  "section": "UpgradePanel",
  "multiline": false
 },
 "upgrade.prefer_to_talk": {
  "default": "Prefer to talk?",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Upgrade / demo locked",
  "label": "Prefer to talk?",
  "section": "UpgradePanel",
  "multiline": false
 },
 "upgrade.send_us_a_message": {
  "default": "Send us a message",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Upgrade / demo locked",
  "label": "Send us a message",
  "section": "UpgradePanel",
  "multiline": false
 },
 "upgrade.log_out": {
  "default": "Log out",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Upgrade / demo locked",
  "label": "Log out",
  "section": "LockScreen",
  "multiline": false
 },
 "upgrade.pick_a_plan_for": {
  "default": "Pick a plan for ",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Upgrade / demo locked",
  "label": "Pick a plan for ",
  "section": "UpgradePanel",
  "multiline": false
 },
 "upgrade.your_products_and_sales_are": {
  "default": "Your products and sales are safe. Choose a plan and our team will reactivate your register — usually the same day.",
  "required": false,
  "placeholders": [],
  "max_length": 342,
  "kind": "string",
  "page": "Upgrade / demo locked",
  "label": "Your products and sales are safe. Choose a plan and our team…",
  "section": "UpgradePanel",
  "multiline": false
 },
 "upgrade.your_products_and_sales_are_2": {
  "default": "Your products and sales are safe. Ask the owner of {name} to choose a plan to reactivate the register.",
  "required": true,
  "placeholders": [
   "name"
  ],
  "max_length": 300,
  "kind": "string",
  "page": "Upgrade / demo locked",
  "label": "Your products and sales are safe. Ask the owner of ",
  "section": "UpgradePanel",
  "multiline": false
 },
 "store.share_on_whatsapp": {
  "default": "Share on WhatsApp",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Share on WhatsApp",
  "section": "ShareOrderButton",
  "multiline": false
 },
 "store.powered_by_smart_in_retail": {
  "default": "Powered by Smart-in Retail",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Powered by Smart-in Retail",
  "section": "StoreMessage",
  "multiline": false
 },
 "store.out_of_stock": {
  "default": "Out of stock",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Out of stock",
  "section": "ProductCard",
  "multiline": false
 },
 "store.add": {
  "default": "Add",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Add",
  "section": "ProductCard",
  "multiline": false
 },
 "store.checkout": {
  "default": "Checkout",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Checkout",
  "section": "Checkout",
  "multiline": false
 },
 "store.mobile_number": {
  "default": "Mobile number",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Mobile number",
  "section": "Checkout",
  "multiline": false
 },
 "store.area": {
  "default": "Area",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Area",
  "section": "Checkout",
  "multiline": false
 },
 "store.items": {
  "default": "Items",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Items",
  "section": "Checkout",
  "multiline": false
 },
 "store.delivery": {
  "default": "Delivery",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Delivery",
  "section": "Checkout",
  "multiline": false
 },
 "store.total": {
  "default": "Total",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Total",
  "section": "Checkout",
  "multiline": false
 },
 "store.try_again": {
  "default": "Try again",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Try again",
  "section": "StoreFront",
  "multiline": false
 },
 "store.we_ll_confirm_shortly": {
  "default": "We'll confirm shortly.",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "We'll confirm shortly.",
  "section": "StoreFront",
  "multiline": false
 },
 "store.track_your_order": {
  "default": "Track your order",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Track your order",
  "section": "StoreFront",
  "multiline": false
 },
 "store.whatsapp": {
  "default": "WhatsApp",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "WhatsApp",
  "section": "StoreFront",
  "multiline": false
 },
 "store.price_low": {
  "default": "Price: low",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Price: low",
  "section": "StoreFront",
  "multiline": false
 },
 "store.price_high": {
  "default": "Price: high",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Price: high",
  "section": "StoreFront",
  "multiline": false
 },
 "store.no_products_found": {
  "default": "No products found",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "No products found",
  "section": "StoreFront",
  "multiline": false
 },
 "store.items_2": {
  "default": "items",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "items",
  "section": "StoreFront",
  "multiline": false
 },
 "store.your_cart": {
  "default": "Your cart",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Your cart",
  "section": "StoreFront",
  "multiline": false
 },
 "store.subtotal": {
  "default": "Subtotal",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "text",
  "page": "Online store (platform copy)",
  "label": "Subtotal",
  "section": "StoreFront",
  "multiline": false
 },
 "store.loading": {
  "default": "Loading…",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Online store (platform copy)",
  "label": "Loading…",
  "section": "StoreFront",
  "multiline": false
 },
 "store.store_not_found": {
  "default": "Store not found",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Online store (platform copy)",
  "label": "Store not found",
  "section": "StoreFront",
  "multiline": false
 },
 "store.we_couldn_t_load_this": {
  "default": "We couldn't load this store",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "attr",
  "page": "Online store (platform copy)",
  "label": "We couldn't load this store",
  "section": "StoreFront",
  "multiline": false
 },
 "store.please_try_again_later": {
  "default": "Please try again later",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Please try again later",
  "section": "Checkout",
  "multiline": false
 },
 "store.your_name": {
  "default": "Your name",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Your name",
  "section": "Checkout",
  "multiline": false
 },
 "store.email_optional": {
  "default": "Email (optional)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Email (optional)",
  "section": "Checkout",
  "multiline": false
 },
 "store.pickup_pay_at_pickup": {
  "default": "Pickup · Pay at pickup",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Pickup · Pay at pickup",
  "section": "Checkout",
  "multiline": false
 },
 "store.delivery_address": {
  "default": "Delivery address",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Delivery address",
  "section": "Checkout",
  "multiline": false
 },
 "store.note_optional": {
  "default": "Note (optional)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Note (optional)",
  "section": "Checkout",
  "multiline": false
 },
 "store.place_order": {
  "default": "Place order",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Place order",
  "section": "Checkout",
  "multiline": false
 },
 "store.check_the_link_and_try": {
  "default": "Check the link and try again.",
  "required": true,
  "placeholders": [],
  "max_length": 87,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Check the link and try again.",
  "section": "StoreFront",
  "multiline": false
 },
 "store.closed": {
  "default": "Closed",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Closed",
  "section": "StoreFront",
  "multiline": false
 },
 "store.search_products": {
  "default": "Search products",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Search products",
  "section": "StoreFront",
  "multiline": false
 },
 "store.store_is_closed": {
  "default": "Store is closed",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Store is closed",
  "section": "StoreFront",
  "multiline": false
 },
 "store.order_not_found": {
  "default": "Order not found",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "attr",
  "page": "Online store (platform copy)",
  "label": "Order not found",
  "section": "OrderTrack",
  "multiline": false
 },
 "store.order_placed": {
  "default": "Order placed",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Order placed",
  "section": "WORD",
  "multiline": false
 },
 "store.accepted": {
  "default": "Accepted",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Accepted",
  "section": "WORD",
  "multiline": false
 },
 "store.ready_for_pickup": {
  "default": "Ready for pickup",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Ready for pickup",
  "section": "WORD",
  "multiline": false
 },
 "store.out_for_delivery": {
  "default": "Out for delivery",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Out for delivery",
  "section": "WORD",
  "multiline": false
 },
 "store.completed": {
  "default": "Completed",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Completed",
  "section": "WORD",
  "multiline": false
 },
 "store.cancelled": {
  "default": "Cancelled",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Cancelled",
  "section": "WORD",
  "multiline": false
 },
 "store.preparing": {
  "default": "Preparing",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Preparing",
  "section": "WORD",
  "multiline": false
 },
 "store.delivered": {
  "default": "Delivered",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Delivered",
  "section": "WORD",
  "multiline": false
 },
 "store.collected": {
  "default": "Collected",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Online store (platform copy)",
  "label": "Collected",
  "section": "WORD",
  "multiline": false
 },
 "landing.stat_speed_value": {
  "default": "< 300ms",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "< 300ms",
  "section": "Hero",
  "multiline": false
 },
 "landing.stat_speed": {
  "default": "scan to cart",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "scan to cart",
  "section": "Hero",
  "multiline": false
 },
 "landing.stat_receipts": {
  "default": "thermal receipts",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "thermal receipts",
  "section": "Hero",
  "multiline": false
 },
 "landing.stat_countries_value": {
  "default": "249",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "249",
  "section": "Hero",
  "multiline": false
 },
 "landing.stat_countries": {
  "default": "countries & tax",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "countries & tax",
  "section": "Hero",
  "multiline": false
 },
 "landing.prices_shown_in": {
  "default": "Prices shown in {currency}.",
  "required": true,
  "placeholders": [
   "currency"
  ],
  "max_length": 81,
  "kind": "string",
  "page": "Landing",
  "label": "Prices shown in {currency}.",
  "section": "Pricing",
  "multiline": false
 },
 "landing.prices_shown_for": {
  "default": "Prices shown in {currency} for {country}.",
  "required": true,
  "placeholders": [
   "currency",
   "country"
  ],
  "max_length": 123,
  "kind": "string",
  "page": "Landing",
  "label": "Prices shown in {currency} for {country}.",
  "section": "Pricing",
  "multiline": false
 },
 "contact.message_too_long": {
  "default": "Keep your message under {max} characters",
  "required": true,
  "placeholders": [
   "max"
  ],
  "max_length": 120,
  "kind": "string",
  "page": "Contact",
  "label": "Keep your message under {max} characters",
  "section": "Field error messages",
  "multiline": false
 },
 "signup.select_your_region": {
  "default": "Select your {region}",
  "required": true,
  "placeholders": [
   "region"
  ],
  "max_length": 80,
  "kind": "string",
  "page": "Signup",
  "label": "Select your {region}",
  "section": "Field error messages",
  "multiline": false
 },
 "landing.cta_start_free_retail": {
  "default": "Start free as a retailer",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Start free as a retailer",
  "section": "General",
  "multiline": false
 },
 "landing.cta_start_free_pharmacy": {
  "default": "Start free as a pharmacy",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Start free as a pharmacy",
  "section": "General",
  "multiline": false
 },
 "landing.cta_start_free_restaurant": {
  "default": "Start free as a restaurant",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Landing",
  "label": "Start free as a restaurant",
  "section": "General",
  "multiline": false
 },
 "landing.nav_faq": {
  "default": "FAQ",
  "required": true,
  "placeholders": [],
  "max_length": 40,
  "kind": "string",
  "page": "Landing",
  "label": "FAQ (nav link)",
  "section": "Header",
  "multiline": false
 },
 "upgrade.days_left": {
  "default": "{days} days left in your free demo. Request a plan any time; nothing is charged online.",
  "required": true,
  "placeholders": [
   "days"
  ],
  "max_length": 300,
  "kind": "string",
  "page": "Upgrade / demo locked",
  "label": "Demo days left",
  "section": "UpgradePanel",
  "multiline": false
 },
 "reseller.become_a_reseller": {
  "default": "Become a Reseller",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Become a Reseller",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.earn_20_of_every_subscription": {
  "default": "Earn 20% of every subscription payment from the shops you bring to Smart-in Retail.",
  "required": false,
  "placeholders": [],
  "max_length": 249,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Earn 20% of every subscription payment from the shops you br…",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.go_to_reseller_login": {
  "default": "Go to reseller login",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Go to reseller login",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.full_name": {
  "default": "Full name",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Full name",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.company_optional": {
  "default": "Company (optional)",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Company (optional)",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.country": {
  "default": "Country",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Country",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.mobile": {
  "default": "Mobile",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Mobile",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.mobile_number": {
  "default": "Mobile number",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Mobile number",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.how_will_you_sell_smart": {
  "default": "How will you sell Smart-in Retail?",
  "required": true,
  "placeholders": [],
  "max_length": 102,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "How will you sell Smart-in Retail?",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.your_city_the_shops_you": {
  "default": "Your city, the shops you know, how you'll reach them…",
  "required": true,
  "placeholders": [],
  "max_length": 159,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Your city, the shops you know, how you'll reach them…",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.this_field_is_required": {
  "default": "This field is required",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "This field is required",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.enter_a_valid_email": {
  "default": "Enter a valid email",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Enter a valid email",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.enter_a_valid_mobile_number": {
  "default": "Enter a valid mobile number",
  "required": true,
  "placeholders": [],
  "max_length": 81,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "Enter a valid mobile number",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "reseller.at_least_6_characters": {
  "default": "At least 6 characters",
  "required": true,
  "placeholders": [],
  "max_length": 80,
  "kind": "string",
  "page": "Become a Reseller",
  "label": "At least 6 characters",
  "section": "Become a Reseller form",
  "multiline": false
 },
 "maintenance.eyebrow": {
  "default": "Scheduled maintenance",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Maintenance",
  "label": "Eyebrow",
  "section": "Maintenance page",
  "multiline": false
 },
 "maintenance.message": {
  "default": "We're making some improvements. We'll be back shortly.",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Maintenance",
  "label": "Message",
  "section": "Maintenance page",
  "multiline": false
 },
 "maintenance.note": {
  "default": "Already a customer? Your register, back office and online store keep working as usual.",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Maintenance",
  "label": "Note",
  "section": "Maintenance page",
  "multiline": false
 },
 "maintenance.login": {
  "default": "Log in to your shop",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Maintenance",
  "label": "Login",
  "section": "Maintenance page",
  "multiline": false
 },
 "login.qr_title": {
  "default": "Scan with Smart-in on your phone",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR title",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_step1": {
  "default": "Open Smart-in on your phone",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR step1",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_step2": {
  "default": "Tap Scan to log in",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR step2",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_step3": {
  "default": "Point at this code",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR step3",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_paused": {
  "default": "Code expired — Tap to refresh",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR paused",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_offline": {
  "default": "QR login needs internet — use your password",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR offline",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_new_code_in": {
  "default": "New code in {seconds}s",
  "required": true,
  "placeholders": [
   "seconds"
  ],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR new code in",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_link": {
  "default": "Log in with QR",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR log in with QR chip",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_err_expired": {
  "default": "This code has expired. Scan the new code on your computer",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR err expired",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_err_used": {
  "default": "This code was already used",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR err used",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_err_invalid": {
  "default": "This isn't a Smart-in login code",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR err invalid",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_scan_button": {
  "default": "Scan to log in",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR scan button",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_logged_in": {
  "default": "Logged in on {device}",
  "required": true,
  "placeholders": [
   "device"
  ],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR logged in",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_loading": {
  "default": "Getting your code…",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR loading",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_logging_in": {
  "default": "Logging you in…",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR logging in",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_retry": {
  "default": "Try again",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR retry",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_scan_hint": {
  "default": "Point your camera at the QR code on the computer's login page",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR scan hint",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_aria": {
  "default": "QR code for logging in with your phone",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR aria",
  "section": "QR login",
  "multiline": false
 },
 "login.qr_use_password": {
  "default": "Log in with username and password",
  "required": true,
  "placeholders": [],
  "max_length": 200,
  "kind": "string",
  "page": "Login",
  "label": "QR use password chip",
  "section": "QR login",
  "multiline": false
 },
 "login.fp_link": {
  "default": "Forgot password?",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp link",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_title": {
  "default": "Reset your password",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp title",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_back": {
  "default": "Back to log in",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp back",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_ask_hint": {
  "default": "Enter your email (owners) or username (staff). We'll send a 6-digit code to your WhatsApp and email.",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp ask hint",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_identifier": {
  "default": "Email or username",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp identifier",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_send_code": {
  "default": "Send code",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp send code",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_code": {
  "default": "6-digit code",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp code",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_new_password": {
  "default": "New password",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp new password",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_confirm_password": {
  "default": "Confirm new password",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp confirm password",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_set_password": {
  "default": "Set new password",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp set password",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_new_code": {
  "default": "Request a new code",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp new code",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_pw_short": {
  "default": "Password must be at least 6 characters",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp pw short",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_pw_mismatch": {
  "default": "Passwords don't match",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp pw mismatch",
  "section": "Forgot password",
  "multiline": false
 },
 "login.fp_done": {
  "default": "Password changed. Log in with your new password.",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Login",
  "label": "fp done",
  "section": "Forgot password",
  "multiline": false
 },
 "signup.whatsapp_number": {
  "default": "WhatsApp number",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Signup",
  "label": "whatsapp number",
  "section": "WhatsApp",
  "multiline": false
 },
 "signup.whatsapp_placeholder": {
  "default": "+92 300 1234567",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Signup",
  "label": "whatsapp placeholder",
  "section": "WhatsApp",
  "multiline": false
 },
 "signup.whatsapp_invalid": {
  "default": "Enter a valid WhatsApp number with country code",
  "required": true,
  "placeholders": [],
  "max_length": 300,
  "kind": "string",
  "page": "Signup",
  "label": "whatsapp invalid",
  "section": "WhatsApp",
  "multiline": false
 }
};
